<template>
  <div class="layout-container">
    <!-- 移动端影视资源站横幅 -->
    <div class="mobile-movie-banner" v-if="isMobile">
      <div class="banner-content" @click="openMovieSite">
        <div class="banner-icon">
          <i class="el-icon-video-camera"></i>
        </div>
        <div class="banner-text">
          <span class="banner-title">🔥 影视资源站</span>
          <span class="banner-subtitle">24小时实时更新 · 点击进入</span>
        </div>
        <div class="banner-arrow">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    
    <el-header class="main-header">
      <div class="logo-container">
        <!-- 移动端菜单按钮 -->
        <div class="menu-toggle" @click="toggleSidebar">
          <i :class="['el-icon-s-unfold', { 'is-active': sidebarVisible }]"></i>
        </div>
        <img :src="systemConfig.website_logo" class="logo" />
        <span class="system-name">{{ systemConfig.website_name }}</span>
      </div>

      <!-- PC端顶部菜单 -->
      <div class="top-menu">
        <router-link to="/" class="menu-item" :class="{ active: $route.path === '/' }">
          <i class="el-icon-s-grid"></i>
          VR游戏搜索
        </router-link>
        <router-link to="/hotRanking" class="menu-item" :class="{ active: $route.path === '/hotRanking' }">
          <i class="el-icon-trophy"></i>
          热门排行
        </router-link>
        <router-link to="/GetMqGame" class="menu-item" :class="{ active: $route.path === '/GetMqGame' }">
          <i class="el-icon-link"></i>
          VR游戏解析
        </router-link>
        <router-link v-if="isAdmin" to="/manage" class="menu-item" :class="{ active: $route.path === '/manage' }">
          <i class="el-icon-user"></i>
          管理后台
        </router-link>
        <router-link v-if="isAgent || isAdmin" to="/agent" class="menu-item" :class="{ active: $route.path === '/agent' }">
          <i class="el-icon-goods"></i>
          代理后台
        </router-link>
      </div>

      <div class="right-menu">
        <!-- 主题切换入口 -->
        <a href="/" class="theme-switch-link">
          <i class="el-icon-moon"></i>
          <span class="btn-text">深色主题</span>
        </a>
        
        <!-- VR助手下载入口 -->
        <!-- <div class="vr-assistant-entrance-btn" @click="openVRAssistant">
          <div class="vr-btn-content">
            <i class="el-icon-mobile-phone"></i>
            <span class="vr-btn-text">{{ systemConfig.website_name }}助手</span>
            <div class="vr-hot-badge">NEW</div>
          </div>
        </div> -->
        
        <!-- 影视资源站入口 -->
        <div class="movie-entrance-btn" @click="openMovieSite">
          <div class="movie-btn-content">
            <i class="el-icon-video-camera"></i>
            <span class="movie-btn-text">影视资源</span>
            <div class="movie-hot-badge">HOT</div>
          </div>
        </div>
        
        <!-- 购买卡密按钮 -->
        <el-button type="text" class="purchase-btn" @click="filterType = 'all';showPurchaseDialog = true;">
          <i class="el-icon-shopping-cart-2"></i>
          <span class="btn-text">购买卡密</span>
        </el-button>
        <template v-if="isLoggedIn">
          <el-button type="text" class="vip-btn" @click="showVipDialog = true">
            <i class="el-icon-shopping-bag-2"></i>
            <span class="btn-text">VIP卡密兑换</span>
          </el-button>

          <el-dropdown trigger="click" @command="handleCommand">
            <div class="avatar-wrapper">
              <el-avatar :size="36" :src="user.avatar" class="user-avatar" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <div class="dropdown-header">
                <span class="username">{{ user.name }}</span>
              </div>
              <div class="dropdown-header">
                <span class="username">{{ getUserTypeLabel() }}</span>
              </div>
              <div class="dropdown-header" v-if="user.vipExpiry">
                <span class="username">会员有效期：{{ user.vipExpiry }}</span>
              </div>
              <el-dropdown-item command="changePassword">
                <i class="el-icon-lock"></i>修改密码
              </el-dropdown-item>
              <el-dropdown-item command="logout">
                <i class="el-icon-switch-button"></i>退出登录
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>

        <router-link v-else to="/login">
          <el-button type="text" class="login-btn">
            <i class="el-icon-user"></i>
            <span class="btn-text">登录/注册</span>
          </el-button>
        </router-link>
      </div>
    </el-header>

    <!-- 移动端侧边栏菜单 -->
    <el-drawer
      :visible.sync="sidebarVisible"
      direction="ltr"
      size="70%"
      class="mobile-sidebar"
    >
      <div class="mobile-menu">
        <router-link to="/" class="mobile-menu-item" :class="{ active: $route.path === '/' }" @click.native="closeMobileSidebar">
          <i class="el-icon-s-grid"></i>
          VR游戏搜索
        </router-link>
        <router-link to="/hotRanking" class="mobile-menu-item" :class="{ active: $route.path === '/hotRanking' }" @click.native="closeMobileSidebar">
          <i class="el-icon-trophy"></i>
          热门排行
        </router-link>
        <router-link to="/GetMqGame" class="mobile-menu-item" :class="{ active: $route.path === '/GetMqGame' }" @click.native="closeMobileSidebar">
          <i class="el-icon-link"></i>
          VR游戏解析
        </router-link>
        <router-link to="/VRAssistant" class="mobile-menu-item vr-assistant-link" :class="{ active: $route.path === '/VRAssistant' }" @click.native="closeMobileSidebar">
          <i class="el-icon-mobile-phone"></i>
          VR助手下载
          <span class="hot-badge">HOT</span>
        </router-link>
        <router-link v-if="isAgent || isAdmin" to="/agent" class="mobile-menu-item" :class="{ active: $route.path === '/agent' }" @click.native="closeMobileSidebar">
          <i class="el-icon-goods"></i>
          代理后台
        </router-link>
        <router-link v-if="isAdmin" to="/manage" class="mobile-menu-item" :class="{ active: $route.path === '/manage' }" @click.native="closeMobileSidebar">
          <i class="el-icon-user"></i>
          管理后台
        </router-link>
      </div>
    </el-drawer>

    <!-- 购买卡密对话框 -->
    <el-dialog
      title="购买卡密"
      :visible.sync="showPurchaseDialog"
      width="500px"
      class="purchase-dialog"
    >
      <div v-loading="purchaseLoading" class="purchase-content">
        <div v-if="purchaseLinks.length === 0" class="empty-state">
          <i class="el-icon-info"></i>
          <p>暂无购买链接</p>
        </div>
        <div v-else class="purchase-links">
          <div
            v-for="(link, index) in purchaseLinks"
            :key="index"
            class="purchase-link-item"
            @click="openPurchaseLink(link.link)"
          >
            <div class="link-info">
              <h4 class="link-name">{{ link.name }}</h4>
              <p class="link-url">{{ link.link }}</p>
            </div>
            <div class="link-actions">
              <el-button type="text" size="small" @click.stop="copyLink(link.link)">
                <i class="el-icon-copy-document"></i>
                复制
              </el-button>
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="showPurchaseDialog = false">关闭</el-button>
        <el-button type="primary" @click="refreshPurchaseLinks">
          <i class="el-icon-refresh"></i>
          刷新
        </el-button>
      </span>
    </el-dialog>

    <!-- VIP充值对话框 -->
    <el-dialog title="VIP卡密兑换" :visible.sync="showVipDialog" width="400px">
      <el-form>
        <el-form-item label="卡密">
          <el-input v-model="cardId" placeholder="请输入VIP卡密"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showVipDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmVip">确定兑换</el-button>
      </span>
    </el-dialog>

    <!-- 修改密码对话框 -->
    <el-dialog title="修改密码" :visible.sync="showPasswordDialog" width="400px">
      <el-form>
        <el-form-item label="原密码">
          <el-input v-model="passwordForm.oldPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="passwordForm.newPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="passwordForm.confirmPassword" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showPasswordDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmPassword">确定修改</el-button>
      </span>
    </el-dialog>

    <div class="main-content">
      <router-view @showVipDialog="handleClickShowVip"></router-view>
    </div>
    
    <!-- 漂浮二维码按钮组 -->
    <div class="floating-qr-buttons">
      <!-- 官方客服二维码按钮 -->
      <div class="qr-button-item" @mouseenter="showCustomerQR = true" @mouseleave="showCustomerQR = false">
        <div class="qr-button customer-service">
          <i class="el-icon-service"></i>
          <span class="button-text">客服</span>
        </div>
        <div class="qr-popup" :class="{ 'show': showCustomerQR }">
          <div class="qr-content">
            <div class="qr-title">官方客服</div>
            <div class="qr-image">
              <!-- 这里放置官方客服二维码图片 -->
              <img :src="systemConfig.customer_service_qr" alt="官方客服二维码" />
            </div>
            <div class="qr-desc">扫码添加官方客服</div>
          </div>
        </div>
      </div>
      
      <!-- 交流群二维码按钮 -->
      <div class="qr-button-item" @mouseenter="showGroupQR = true" @mouseleave="showGroupQR = false">
        <div class="qr-button group-chat">
          <i class="el-icon-chat-dot-round"></i>
          <span class="button-text">群聊</span>
        </div>
        <div class="qr-popup" :class="{ 'show': showGroupQR }">
          <div class="qr-content">
            <div class="qr-title">交流群</div>
            <div class="qr-image">
              <!-- 这里放置交流群二维码图片 -->
              <img :src="systemConfig.chat_group_qr" alt="交流群二维码" />
            </div>
            <div class="qr-desc">扫码加入交流群</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cardExchange, changePassword, logout, getSettings, getPublicSystemConfig } from "@/api";

export default {
  name: "Layout",
  data() {
    return {
      isMobile: false,
      showCustomerQR: false,
      showGroupQR: false,
      sidebarVisible: false,
      isLoggedIn: false,
      showVipDialog: false,
      showPasswordDialog: false,
      showPurchaseDialog: false,
      filterType: "all",
      purchaseLoading: false,
      activeMenu: "/",
      cardId: "",
      purchaseLinks: [],
      domain: "",
      isMobile: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      user: {
        name: "测试用户",
        vipLevel: 0,
        vipExpiry: "",
        avatar: require("@/assets/game.jpg"),
      },
      // 系统配置
      systemConfig: {
        website_logo: null,
        website_name: "",
        customer_service_qr: null,
        chat_group_qr: null,
        third_party_config: {}
      }
    };
  },

  computed: {
    isAdmin() {
      return this.user && this.user.role === "admin";
    },
    isAgent() {
      return this.user && this.user.role === "agent";
    },
  },

  mounted() {
    this.isLoggedIn = localStorage.getItem("token") ? true : false;
    if (this.isLoggedIn) {
      this.user = JSON.parse(localStorage.getItem("userInfo"));
    }
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.loadSystemConfig();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },

  watch: {
    $route(to) {
      this.activeMenu = to.path;
    },

    showPurchaseDialog(newVal) {
      if (newVal) {
        this.fetchPurchaseLinks();
      }
    },
  },

  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },

    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },

    handleMenuSelect(index) {
      if (this.$route.path === index) {
        return false;
      }
      this.$router.push(index);
      this.sidebarVisible = false;
    },

    closeMobileSidebar() {
      this.sidebarVisible = false;
    },
    openMovieSite() {
      window.open('https://pan.365wp.top/', '_blank');
    },

    openVRAssistant() {
      this.$router.push('/VRAssistant');
    },

    async handleCommand(command) {
      if (command === "changePassword") {
        this.showPasswordDialog = true;
      }
      if (command === "logout") {
        try {
          await logout();
          localStorage.removeItem("token");
          this.isLoggedIn = false;
          localStorage.removeItem("userInfo");
          this.user = {};
          this.$router.push("/login");
        } catch (error) {
          console.log(error);
        }
      }
    },

    // 获取购买链接
    async fetchPurchaseLinks() {
      this.purchaseLoading = true;
      try {
        // 这里需要根据实际的API接口进行调用
        // 假设API接口为 /api/purchase-links
        const domain = location.host;
        const response = await getSettings({ domain});
        console.log(response);
        if (response.data.purchase_link.length) {
          if(this.filterType === "all"){
            this.purchaseLinks = response.data.purchase_link;
          }else{
            this.purchaseLinks = response.data.purchase_link.filter(item => item.name.indexOf(this.filterType) !== -1);
          }
          
        } else {
          this.purchaseLinks = [];
          this.$message.error("暂无购买链接");
        }
      } catch (error) {
        console.error("获取购买链接失败:", error);
        this.$message.error("获取购买链接失败");
      } finally {
        this.purchaseLoading = false;
      }
    },

    // 刷新购买链接
    refreshPurchaseLinks() {
      this.fetchPurchaseLinks();
    },

    // 打开购买链接
    openPurchaseLink(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },

    // 复制链接
    async copyLink(url) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
        } else {
          // 降级方案
          const textArea = document.createElement("textarea");
          textArea.value = url;
          textArea.style.position = "fixed";
          textArea.style.left = "-999999px";
          textArea.style.top = "-999999px";
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          document.execCommand("copy");
          textArea.remove();
        }
        this.$message.success("链接已复制到剪贴板");
      } catch (error) {
        console.error("复制失败:", error);
        this.$message.error("复制失败");
      }
    },

    confirmVip() {
      if (!this.cardId) {
        this.$message.warning("请输入卡密");
        return;
      }

      cardExchange({ cardId: this.cardId })
        .then((res) => {
          this.showVipDialog = false;
          this.$message.success("兑换成功");
          localStorage.removeItem("token");
          this.isLoggedIn = false;
          localStorage.removeItem("userInfo");
          this.user = {};
          this.$router.push("/login");
          this.cardId = "";
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    confirmPassword() {
      const { oldPassword, newPassword, confirmPassword } = this.passwordForm;

      if (!oldPassword) {
        this.$message.error("原密码不能为空");
        return;
      }

      if (newPassword !== confirmPassword) {
        this.$message.error("两次输入的密码不一致");
        return;
      }

      if (oldPassword === newPassword) {
        this.$message.error("新密码不能与原密码相同");
        return;
      }

      changePassword(this.passwordForm)
        .then((response) => {
          if (response.code === 200) {
            this.$message.success("密码修改成功");
            this.showPasswordDialog = false;
            localStorage.removeItem("token");
            this.isLoggedIn = false;
            localStorage.removeItem("userInfo");
            this.user = {};
            this.$router.push("/login");
            this.passwordForm = {
              oldPassword: "",
              newPassword: "",
              confirmPassword: "",
            };
          } else {
            this.$message.error(response.message);
          }
        })
        .catch((error) => {
          console.error("修改密码失败:", error);
          this.$message.error("修改密码失败");
        });
    },

    handleClickShowVip(type='all') {
      this.filterType = type;
      this.showPurchaseDialog = true;
    },

    // 加载系统配置
    async loadSystemConfig() {
      const cacheKey = 'system_config_cache';
      const cacheTimeKey = 'system_config_cache_time';
      const cacheExpireHours = 24; // 24小时过期
      
      try {
        // 检查缓存
        const cachedConfig = localStorage.getItem(cacheKey);
        const cacheTime = localStorage.getItem(cacheTimeKey);
        
        if (cachedConfig && cacheTime) {
          const cacheTimestamp = parseInt(cacheTime);
          const currentTime = Date.now();
          const timeDiff = currentTime - cacheTimestamp;
          const hoursDiff = timeDiff / (1000 * 60 * 60);
          
          // 如果缓存未过期（小于24小时），使用缓存数据
          if (hoursDiff < cacheExpireHours) {
            const parsedConfig = JSON.parse(cachedConfig);
            this.systemConfig = {
              website_logo: parsedConfig.website_logo || this.systemConfig.website_logo,
              website_name: parsedConfig.website_name || this.systemConfig.website_name,
              customer_service_qr: parsedConfig.customer_service_qr || this.systemConfig.customer_service_qr,
              chat_group_qr: parsedConfig.chat_group_qr || this.systemConfig.chat_group_qr,
              third_party_config: parsedConfig.third_party_config || this.systemConfig.third_party_config
            };
            console.log('使用缓存的系统配置');
            return;
          }
        }
        
        // 缓存不存在或已过期，请求接口
        const domain = location.host;
        const response = await getPublicSystemConfig({ domain });
        if (response.data) {
          // 更新系统配置，保留默认值作为后备
          this.systemConfig = {
            website_logo: response.data.website_logo || this.systemConfig.website_logo,
            website_name: response.data.website_name || this.systemConfig.website_name,
            customer_service_qr: response.data.customer_service_qr || this.systemConfig.customer_service_qr,
            chat_group_qr: response.data.chat_group_qr || this.systemConfig.chat_group_qr,
            third_party_config: response.data.third_party_config || this.systemConfig.third_party_config
          };
          
          // 缓存新数据和时间戳
          localStorage.setItem(cacheKey, JSON.stringify(response.data));
          localStorage.setItem(cacheTimeKey, Date.now().toString());
          console.log('已更新系统配置缓存');
        }
      } catch (error) {
        console.error('加载系统配置失败:', error);
        // 失败时尝试使用缓存数据
        const cachedConfig = localStorage.getItem(cacheKey);
        if (cachedConfig) {
          try {
            const parsedConfig = JSON.parse(cachedConfig);
            this.systemConfig = {
              website_logo: parsedConfig.website_logo || this.systemConfig.website_logo,
              website_name: parsedConfig.website_name || this.systemConfig.website_name,
              customer_service_qr: parsedConfig.customer_service_qr || this.systemConfig.customer_service_qr,
              chat_group_qr: parsedConfig.chat_group_qr || this.systemConfig.chat_group_qr,
              third_party_config: parsedConfig.third_party_config || this.systemConfig.third_party_config
            };
            console.log('接口请求失败，使用缓存的系统配置');
          } catch (parseError) {
            console.error('解析缓存配置失败:', parseError);
          }
        }
        // 失败时使用默认配置，不显示错误信息给用户
      }
    },
      // 获取用户类型标签
  getUserTypeLabel() {
    // 如果不是会员（vipLevel为0）
    if (this.user.vipLevel == 0) {
      return "普通用户";
    }
    
    // 如果是永久会员（vipLevel为9）
    if (this.user.vipLevel == 9) {
      // 根据vipType区分永久会员类型
      if (this.user.vipType === 'basic') {
        return "魔趣解析永久会员";
      } else if (this.user.vipType === 'premium') {
        return "全能高级永久会员";
      } else {
        return "永久会员"; // 兼容旧数据
      }
    }
    
    // 其他等级的会员
    if (this.user.vipType === 'basic') {
      return "魔趣解析会员";
    } else if (this.user.vipType === 'premium') {
      return "全能高级会员";
    } else {
      return "会员用户"; // 兼容旧数据
    }
  },
  },
};
</script>

<style lang="scss" scoped>
.layout-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.main-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 0 20px;
  height: 60px;
  position: relative;
}

.menu-toggle {
  display: none;
  padding: 0 15px;
  cursor: pointer;
  font-size: 20px;
  color: #606266;

  &:hover {
    color: #409eff;
  }

  .is-active {
    color: #409eff;
  }
}

.logo-container {
  display: flex;
  align-items: center;

  .logo {
    width: 36px;
    height: 36px;
    margin-right: 12px;
    border-radius: 4px;
  }

  .system-name {
    font-size: 18px;
    color: #2c3e50;
    font-weight: 500;
  }
}

.top-menu {
  flex: 1;
  margin: 0 30px;
  display: flex;
  align-items: center;
  gap: 20px;

  .menu-item {
    display: flex;
    align-items: center;
    height: 60px;
    padding: 0 16px;
    color: #303133;
    text-decoration: none;
    font-size: 15px;
    transition: all 0.3s ease;
    border-radius: 4px;
    position: relative;

    &:hover {
      color: #409EFF;
      background-color: #f5f7fa;
    }

    &.active {
      color: #409EFF;
      background-color: #ecf5ff;
    }

    i {
      margin-right: 6px;
      font-size: 16px;
    }

    &.vr-assistant-link {
      .hot-badge {
        position: absolute;
        top: 8px;
        right: 8px;
        background: #ff4757;
        color: white;
        font-size: 10px;
        padding: 2px 6px;
        border-radius: 8px;
        font-weight: bold;
      }
    }
  }
}

.right-menu {
  display: flex;
  align-items: center;
  gap: 16px;

  .theme-switch-link {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 8px;
    color: #606266;
    text-decoration: none;
    font-size: 14px;
    transition: all 0.3s ease;
    background: #f5f7fa;

    &:hover {
      background: #e4e7ed;
      color: #409eff;
    }

    i {
      font-size: 16px;
    }
  }

  .vip-btn,
  .login-btn,
  .purchase-btn {
    font-size: 14px;

    i {
      margin-right: 4px;
    }
  }

  .purchase-btn {
    color: #67c23a;

    &:hover {
      color: #529b2e;
    }
  }

  .avatar-wrapper {
    cursor: pointer;

    .user-avatar {
      transition: transform 0.3s;

      &:hover {
        transform: scale(1.1);
      }
    }
  }
}

.dropdown-header {
  padding: 10px 15px;
  border-bottom: 1px solid #ebeef5;

  &:last-child {
    border-bottom: none;
  }

  .username {
    font-size: 14px;
    color: #606266;
  }
}

.mobile-sidebar {
  .el-drawer__body {
    padding: 0;
  }

  .mobile-menu {
    display: flex;
    flex-direction: column;
    padding: 20px 0;

    .mobile-menu-item {
      display: flex;
      align-items: center;
      height: 50px;
      padding: 0 20px;
      color: #303133;
      text-decoration: none;
      font-size: 15px;
      transition: all 0.3s ease;
      position: relative;

      &:hover {
        color: #409EFF;
        background-color: #f5f7fa;
      }

      &.active {
        color: #409EFF;
        background-color: #ecf5ff;
      }

      i {
        margin-right: 12px;
        font-size: 16px;
      }

      &.vr-assistant-link {
        .hot-badge {
          position: absolute;
          top: 8px;
          right: 20px;
          background: #ff4757;
          color: white;
          font-size: 10px;
          padding: 2px 6px;
          border-radius: 8px;
          font-weight: bold;
        }
      }
    }
  }
}

.main-content {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

// 购买卡密对话框样式
.purchase-dialog {
  .purchase-content {
    min-height: 200px;
  }

  .empty-state {
    text-align: center;
    padding: 40px 0;
    color: #909399;

    i {
      font-size: 48px;
      margin-bottom: 16px;
      display: block;
    }

    p {
      margin: 0;
      font-size: 14px;
    }
  }

  .purchase-links {
    .purchase-link-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px;
      margin-bottom: 12px;
      background: #f8f9fa;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: #e3f2fd;
        border-color: #409eff;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
      }

      &:last-child {
        margin-bottom: 0;
      }

      .link-info {
        flex: 1;
        min-width: 0;

        .link-name {
          margin: 0 0 4px 0;
          font-size: 16px;
          font-weight: 500;
          color: #303133;
        }

        .link-url {
          margin: 0;
          font-size: 12px;
          color: #909399;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .link-actions {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;

        .el-button {
          padding: 4px 8px;
          font-size: 12px;
        }

        .el-icon-right {
          color: #c0c4cc;
          font-size: 14px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .menu-toggle {
    display: block;
  }

  .top-menu {
    display: none;
  }

  .system-name {
    display: none;
  }

  .right-menu {
    .btn-text {
      display: none;
    }

    .vip-btn,
    .login-btn,
    .purchase-btn {
      padding: 0 8px;
    }
  }

  .main-content {
    padding: 15px;
  }

  .purchase-dialog {
    .purchase-links {
      .purchase-link-item {
        .link-info {
          .link-name {
            font-size: 14px;
          }
        }
      }
    }
  }
}


/* 漂浮二维码按钮样式 */
.floating-qr-buttons {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.qr-button-item {
  position: relative;
}

.qr-button {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  color: white;
  font-size: 12px;
  
  &.customer-service {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    
    &:hover {
      transform: scale(1.1);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
    }
  }
  
  &.group-chat {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    
    &:hover {
      transform: scale(1.1);
      box-shadow: 0 6px 20px rgba(240, 147, 251, 0.4);
    }
  }
  
  i {
    font-size: 20px;
    margin-bottom: 2px;
  }
  
  .button-text {
    font-size: 10px;
    line-height: 1;
  }
}

.qr-popup {
  position: absolute;
  right: 75px;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  padding: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  min-width: 200px;
  
  &.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(-50%) translateX(-10px);
  }
  
  &::after {
    content: '';
    position: absolute;
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid white;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
  }
}

.qr-content {
  padding: 20px;
  text-align: center;
  
  .qr-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 15px;
  }
  
  .qr-image {
    margin-bottom: 15px;
    
    img {
      width: 150px;
      height: 150px;
      border-radius: 8px;
      border: 1px solid #e4e7ed;
    }
  }
  
  .qr-desc {
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
  }
}

/* VR助手入口按钮样式 */
.vr-assistant-entrance-btn {
  background: linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%);
  border-radius: 12px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 12px;
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

.vr-assistant-entrance-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);
}

.vr-btn-content {
  display: flex;
  align-items: center;
  gap: 6px;
  position: relative;
  color: white;
}

.vr-btn-content i {
  font-size: 16px;
}

.vr-btn-text {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

.vr-hot-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #FF3742;
  color: white;
  font-size: 8px;
  padding: 1px 4px;
  border-radius: 6px;
  font-weight: bold;
  line-height: 1;
}

/* 横幅样式 */
.vr-assistant-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 20px;
  position: relative;
  z-index: 999;
}

.banner-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.banner-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.banner-icon {
  font-size: 24px;
  color: white;
}

.banner-text h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.banner-text p {
  margin: 2px 0 0 0;
  font-size: 12px;
  opacity: 0.9;
}

.banner-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* PC端右侧影视资源站入口 */
.movie-entrance-btn {
  margin-right: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.movie-btn-content {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: linear-gradient(135deg, #4ECDC4 0%, #44A08D 100%);
  border-radius: 12px;
  color: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(78, 205, 196, 0.3);
}

.movie-btn-content:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(78, 205, 196, 0.4);
}

.movie-btn-content i {
  font-size: 16px;
  margin-right: 6px;
}

.movie-btn-text {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.movie-hot-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #FF6B35;
  color: white;
  font-size: 9px;
  padding: 2px 5px;
  border-radius: 8px;
  font-weight: bold;
  animation: pulse-badge 2s infinite;
}

@keyframes pulse-badge {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  }
  50% {
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.5);
  }
  100% {
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-3px);
  }
  60% {
    transform: translateY(-2px);
  }
}

/* 移动端影视资源站横幅 */
.mobile-movie-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 0;
  position: relative;
  overflow: hidden;
}

.mobile-movie-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  animation: shine 3s infinite;
}

.banner-content {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
}

.banner-content:active {
  background: rgba(255,255,255,0.1);
}

.banner-icon {
  font-size: 24px;
  margin-right: 12px;
  animation: pulse 2s infinite;
}

.banner-text {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.banner-title {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 2px;
}

.banner-subtitle {
  font-size: 12px;
  opacity: 0.9;
  line-height: 1.2;
}

.banner-arrow {
  font-size: 18px;
  opacity: 0.8;
  animation: bounce-horizontal 1.5s infinite;
}

@keyframes shine {
  0% { left: -100%; }
  50% { left: 100%; }
  100% { left: 100%; }
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

@keyframes bounce-horizontal {
  0%, 20%, 50%, 80%, 100% {
    transform: translateX(0);
  }
  40% {
    transform: translateX(3px);
  }
  60% {
    transform: translateX(2px);
  }
}

/* 移动端适配 */

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .vr-assistant-entrance-btn {
    margin-right: 8px;
    padding: 6px 8px;
  }
  
  .vr-btn-text {
    display: none;
  }
  
  .vr-btn-content i {
    font-size: 18px;
  }
  
  .vr-assistant-banner {
    padding: 8px 15px;
  }
  
  .banner-content {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
  
  .banner-text h3 {
    font-size: 14px;
  }
  
  .banner-text p {
    font-size: 11px;
  }
  
  .movie-entrance-btn {
    margin-right: 8px;
  }
  
  .movie-btn-content {
    padding: 6px 10px;
  }
  
  .movie-btn-text {
    display: none;
  }
  
  .movie-btn-content i {
    margin-right: 0;
    font-size: 18px;
  }
}

/* 超小屏幕适配 */
@media screen and (max-width: 480px) {
  .right-menu {
    gap: 4px;
  }
  
  .vr-assistant-entrance-btn {
    padding: 4px 6px;
  }
  
  .vr-hot-badge {
    font-size: 7px;
    padding: 1px 3px;
  }
}
</style>
